import React from "react";
import {Paths} from "../../app/components/sidebar/Paths";
import LinkComponent, {ALinkTarget} from "../../app/components/link/LinkComponent";
import {ScreenComponent} from "../../app/components/screen/ScreenComponent";
import {GradientHeaderComponent} from "../../app/components/gradientheader/GradientHeaderComponent";
import {H3SectionComponent} from "../../app/components/section/SectionComponent";

export default function ITGeneralScreen() {
    return (<ScreenComponent>
        <Header/>
        <GetOutPutIn/>
        <ForTheMoney/>
        <CodingWorth/>
        <CompanyCost/>
    </ScreenComponent>)
}

function Header() {
    return (<GradientHeaderComponent title="General Interview Tips"/>)
}

function GetOutPutIn() {
    return (<H3SectionComponent header="You will get out what you put into the process." removeTopPadding={true}>
        <p>This is going to be a very difficult process for many. These jobs are <i>hard</i> to get. Even for
            the most talented of engineers, there is a game to be played that isn't well-known, or learned,
            during the day-to-days of the job. The only way to make it through is to put in the work.</p>
    </H3SectionComponent>)
}

function ForTheMoney() {
    return (
        <H3SectionComponent header="If you only want FAANG for the money, I'd strongly encourage you to just... not.">
            <p>Like I mentioned above, it's a lot of work. A lot of stress. A lot of time and effort, and in some
                cases, your own money goes into these interviews. These companies have been known to burn people out
                quickly. FAANG is not for everyone, though most discourse you find makes you feel like a failure if
                you aren't going after FAANG, or able to get into one. You can get into a FAANG company while hating
                the job, but no job is worth doing if you hate it that much. In this economy, I get it. We've got
                bills to pay, right? But you can still pay your bills as a non-FAANG software engineer and coast
                your whole life, without having to kill yourself trying to get in at FAANG and keep your job there
                (especially at a time of mass layoffs). There's no shame in that.</p>
        </H3SectionComponent>)
}

function CodingWorth() {
    return (<H3SectionComponent header="Coding is not everything. It's not even worth half of your score.">
        <p>I think the biggest mistake I see people make is putting all of their eggs in the basket of LeetCode
            - finding the most optimal solution. It's important, sure, but it's not even close to the most
            important part. More on this <LinkComponent link={Paths.interviewTips.nested.behavioral.path}
                                                        target={ALinkTarget.internal}>here</LinkComponent>.</p>
    </H3SectionComponent>)
}

function CompanyCost() {
    return (<H3SectionComponent header="Interviewing someone costs the company a lot of money.">
        <p>Companies want to remove people from the process as quickly as they possibly can. Make sure to take
            pre-screenings seriously. Majority of cuts happen at this point.</p>
    </H3SectionComponent>)
}
